import currency from 'currency.js';

export const sumAmounts = (amounts: number[]): number =>
    amounts.reduce((accumulator, currentValue) => currency(accumulator).add(currentValue).value, 0);
